import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicNavbar from '../../components/PublicNavbar';
import Footer from '../../components/Footer';

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('terms.title', 'Terms of Service')}</h1>
        <p className="text-sm text-gray-500 mb-8">{t('terms.lastUpdated', 'Last updated')}: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="prose prose-gray max-w-none">
          <h2>{t('terms.s1Title', '1. Acceptance of Terms')}</h2>
          <p>{t('terms.s1Body', 'By accessing or using BuildMyShifts ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.')}</p>

          <h2>{t('terms.s2Title', '2. Description of Service')}</h2>
          <p>{t('terms.s2Body', 'BuildMyShifts is a cloud-based shift management and rota planning platform. We provide tools for creating schedules, managing staff availability, processing shift swaps, and generating analytics.')}</p>

          <h2>{t('terms.s3Title', '3. Account Registration')}</h2>
          <p>{t('terms.s3Body', 'You must provide accurate information when creating an account. You are responsible for maintaining the security of your account and password. You must notify us immediately of any unauthorised access.')}</p>

          <h2>{t('terms.s4Title', '4. Subscription & Billing')}</h2>
          <p>{t('terms.s4Body', 'BuildMyShifts offers a 14-day free trial. After the trial period, a paid subscription is required to continue using the Service. Subscriptions are billed monthly at the current published rate. Payments are processed through Stripe.')}</p>

          <h2>{t('terms.s5Title', '5. Data & Privacy')}</h2>
          <p>{t('terms.s5Body', 'Your data is stored securely using Google Firebase infrastructure. We process data in accordance with our Privacy Policy and applicable data protection laws including GDPR.')}</p>

          <h2>{t('terms.s6Title', '6. Acceptable Use')}</h2>
          <p>{t('terms.s6Body', 'You agree not to misuse the Service, including but not limited to: attempting to gain unauthorised access, interfering with other users, or using the Service for illegal purposes.')}</p>

          <h2>{t('terms.s7Title', '7. Intellectual Property')}</h2>
          <p>{t('terms.s7Body', 'The Service and its original content, features, and functionality are owned by BuildMyShifts and are protected by international copyright, trademark, and other intellectual property laws.')}</p>

          <h2>{t('terms.s8Title', '8. Limitation of Liability')}</h2>
          <p>{t('terms.s8Body', 'The Service is provided "as is" without warranties of any kind. In no event shall BuildMyShifts be liable for any indirect, incidental, special, or consequential damages.')}</p>

          <h2>{t('terms.s9Title', '9. Termination')}</h2>
          <p>{t('terms.s9Body', 'We may terminate or suspend your account at any time for violation of these Terms. You may cancel your subscription at any time through your account settings or by contacting support.')}</p>

          <h2>{t('terms.s10Title', '10. Changes to Terms')}</h2>
          <p>{t('terms.s10Body', 'We reserve the right to modify these terms at any time. We will notify users of material changes via email or in-app notification.')}</p>

          <h2>{t('terms.s11Title', '11. Contact')}</h2>
          <p>{t('terms.s11Body', 'For questions about these Terms, contact us at')} <a href="mailto:support@buildmyshifts.com" className="text-primary">support@buildmyshifts.com</a>.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
